import { motion } from "framer-motion";
import { EASE } from "../../lib/site";

export const MaskLine = ({ children, delay = 0, className = "", wrapperClassName = "" }) => (
  <span className={`block overflow-hidden pb-[0.06em] pr-[0.1em] -mr-[0.1em] ${wrapperClassName}`}>
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.15, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow flex items-center gap-3 ${className}`}>
    <span className="h-px w-10 bg-current opacity-60" aria-hidden="true" />
    {children}
  </p>
);
